import './ConfirmationModal.scss';
class ConfirmationModalController {
    static $inject = ['close', 'title', 'body', 'buttons', 'size', 'modalClass', 'modalSizeClass', 'bodyClass', 'bodyContentClass', 'footerClass', 'footerContentClass', 'theme'];
    constructor(close, title, body, buttons, size, modalClass, modalSizeClass, bodyClass, bodyContentClass, footerClass, footerContentClass, theme) {
        this.close = close;
        this.title = title;
        this.body = body;
        this.buttons = buttons;
        this.size = size;
        this.modalClass = modalClass;
        this.modalSizeClass = modalSizeClass;
        this.bodyClass = bodyClass;
        this.bodyContentClass = bodyContentClass;
        this.footerClass = footerClass;
        this.footerContentClass = footerContentClass;
        this.theme = theme;
        this._close = this.close;
    }
    confirm() {
        this._close(true);
    }
    cancel() {
        this._close(false);
    }
    get isSingleButton() {
        return ((this.buttons.cancel && !this.buttons.confirm) ||
            (!this.buttons.cancel && this.buttons.confirm));
    }
    get button() {
        return this.isSingleButton
            ? this.buttons.cancel || this.buttons.confirm
            : undefined;
    }
}
ConfirmationModalController.$inject = ['close', 'title', 'body', 'buttons', 'size', 'modalClass', 'modalSizeClass', 'bodyClass', 'bodyContentClass', 'footerClass', 'footerContentClass', 'theme'];
export default ConfirmationModalController;
